import { AddressElement, Elements, useStripe } from '@stripe/react-stripe-js';
import { parsePhoneNumberWithError } from 'libphonenumber-js';
import { appearance, cssSrc } from './stripeStyles';

function separateCountryCode(phoneNumber, country = 'US') {
  try {
    const parsed = parsePhoneNumberWithError(phoneNumber, country);

    return {
      countryCode: parsed.countryCallingCode,
      nationalNumber: parsed.nationalNumber,
    };
  } catch (error) {
    return null;
  }
}

const getDefaultAddress = (address) => ({
  name: address.name || '',
  address: {
    line1: address.address || '',
    line2: address.address2 || '',
    city: address.city || '',
    country: address.country || '',
    state: address.state || '',
    postal_code: address.zip || '',
  },
});

export const StripeShippingAddress = ({ locale, address, isPhoneRequired, onAddressChange, onCompleteChanged }) => {
  const stripe = useStripe();

  const stripeLocale = locale.split('-')[0].toLowerCase();

  const onChange = ({ value, complete }) => {
    const phone = separateCountryCode(value.phone, value.address.country);
    onCompleteChanged(complete);
    onAddressChange({
      name: value.name,
      address: value.address.line1,
      address2: value.address.line2,
      city: value.address.city,
      country: value.address.country,
      state: value.address.state,
      zip: value.address.postal_code,
      phone: phone?.nationalNumber,
      countryCode: phone?.countryCode,
    });
  };

  return (
    <Elements
      stripe={stripe}
      options={{
        appearance,
        locale: stripeLocale,
        fonts: [{ cssSrc }]
      }}
    >
      <AddressElement
        options={{
          mode: 'shipping',
          fields: {
            phone: isPhoneRequired ? 'always' : 'never',
          },
          validation: isPhoneRequired ? {
            phone: {
              required: 'always',
            },
          } : undefined,
          defaultValues: getDefaultAddress(address),
        }}
        onChange={onChange}
      />
    </Elements>
  );
};
